import React, { useState, useEffect } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
import axios from "axios";
import routes from "../../../app/routes";
import Table from "./TableMembers";

export default function IndexMembers({ className, cycle, teamId, showCycles }) {
  const [collection, setCollection] = useState([]);
  const [statistics, setStatistics] = useState({});

  const [loaded, setLoaded] = useState(false);

  const updateCollection = () => {
    setLoaded(true);
    axios.get(routes.api.cycles.members(cycle.id, teamId)).then((resp) => {
      setCollection(resp.data.data.collection);
      setStatistics(resp.data.data.statistics);
      setLoaded(false);
    });
  };

  useEffect(() => {
    setLoaded(true);
    updateCollection();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h2>Members for cycle {cycle.attributes.title}</h2>
          {!loaded && (
            <Row className="mt20">
              <Col xs={12}>
                <b className="pr10">
                  Total number of members: {statistics.count_members}
                </b>
                <b className="pr10">
                  Total cost of all programs: {statistics.programs_cost}
                </b>
                <b className="pr10">Totally paid: {statistics.totally_paid}</b>
              </Col>
            </Row>
          )}
        </div>
        <div className="col-md-4 text-right">
          <Button bsStyle="primary" onClick={showCycles}>
            Back to Cycles
          </Button>
        </div>
      </div>
      <div>
        {loaded && <p className="text-center mt20">Processing...</p>}
        {!loaded && <Table collection={collection} />}
      </div>
    </>
  );
}
